// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__g3lw8","backIcon":"BackButton_backIcon__osci3"};